import PutCartItem from '@/models/cart/apiParam/PutCartItem';
import CartPurchaseParam from '@/models/cart/apiParam/CartPurchaseParam';
import { Repository, RepositoryBase } from '@/repository/base';

/**
 * 買い物カゴ関連リポジトリアクセス
 */
export default class CartRepository extends RepositoryBase {
  private repository = '/cart';

  /**
   * 新規作成
   */
  getNewCart() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}`, config);
  }

  /**
   * 情報取得
   */
  getCart(cartCode: string) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}/${cartCode}`, config);
  }

  /**
   * 情報取得
   */
  putCartItem(params: PutCartItem) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.put(`${this.repository}/${params.cartCode}`, this.convert.serialize(params), config);
  }

  /**
   * 買い物カゴ決済
   * @param param 購入用パラメータ
   * @returns レスポンス
   */
  purchaseCart(param: CartPurchaseParam) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.post(`${this.repository}/${param.cartCode}/purchase`, this.convert.serialize(param), config);
  }
}
